import {getDefaultState} from '@/store/modules/bs_myp/state'

export const SET_FROM_LIST_ORDER = 'SET_FROM_LIST_ORDER'
export const RESET_STATE = 'RESET_STATE'

export default {
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  },
  [SET_FROM_LIST_ORDER](state, fromListOrder) {
    state.fromListOrder = fromListOrder
  }
}